import { safePrune } from "PFCore/helpers/safe_prune";

import css from "./cards.module.scss";

export type FeedCardItem = {
  image_url: string;
  title: string;
  link: string;
};

type FeedCardProps = {
  item: FeedCardItem;
};

export const FeedCard = ({ item }: FeedCardProps) => {
  const title = safePrune(item.title, 95);

  return (
    <a className={css.feed} href={item.link} target="_blank" rel="noopener noreferrer">
      <div className={css.imageWrapper}>
        <img src={item.image_url} className={css.image} alt="" />
      </div>
      <div className={css.description}>{title}</div>
    </a>
  );
};
